import React, { useState, useEffect, useRef } from 'react';
import styles from '../../../Components/DropDownSelect/Dropdown.module.css';

function UsersAccessFilter(props) {
  const options = [
    { value: '', label: 'All' },
    { value: '1', label: 'Allowed' },
    { value: '0', label: 'Not Allowed' },
  ];

  const handleSelect = (event) => {
    props.onSelect(event.target.value);
  };

  const getSelectedLabel = (value) => {
    const option = options.find(opt => opt.value === value);
    return option ? option.label : options[0].label;
  };

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(getSelectedLabel(props.value));
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    if (!props.disabled) {
      setIsOpen(!isOpen);
    }
  };

  const selectOption = (option) => {
    setSelectedOption(option.label);
    setIsOpen(false);
    handleSelect({ target: { value: option.value } });
  };

  useEffect(() => {
    setSelectedOption(getSelectedLabel(props.value));
  }, [props.value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!props.disabled && dropdownRef.current && !dropdownRef.current.contains(event.target) && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, props.disabled]);

  return (
    <div className={`${styles.dropdown} ${props.disabled ? styles.dropdownDisabled : ''}`} ref={dropdownRef}>
      <div className={styles.dropdownSelected} onClick={toggleDropdown}>
        {selectedOption}
      </div>
      {isOpen && (
        <div className={styles.dropdownOptions}>
          {options.map((opt) => (
            <div key={opt.value} className={styles.dropdownOption} onClick={() => selectOption(opt)}>
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default UsersAccessFilter;

